"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    type: "object",
    properties: {
        services: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    service: {
                        type: "string",
                    },
                    status: {
                        type: "number",
                        oneOf: [
                            {
                                const: 1,
                                title: "Pending",
                            },
                            {
                                const: 2,
                                title: "Active",
                            },
                            {
                                const: 3,
                                title: "Discharged",
                            },
                        ],
                    },
                },
            },
        },
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
    required: ["notes"],
};
